
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cashback/comdirect",
      function () {
        return require("private-next-pages/cashback/comdirect.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cashback/comdirect"])
      });
    }
  